import React from 'react';
import { Card, Form, Input, Button, Typography, Spin, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import styled, { keyframes } from 'styled-components';
import { useAppDispatch, useAppSelector } from '../Modules/Presentation/hooks';
import { selectAuth } from '../Modules/User/Presentation/selectors';
import { useNavigate } from 'react-router-dom';
import { loginThunk } from '../Modules/User/Presentation/actions';

const { Title, Text } = Typography;

const wave = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: 400% 0; }
`;

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(120deg, #daecd6, #fff);
  position: relative;
  overflow: hidden;
`;

const StyledCard = styled(Card)`
  width: 380px;
  border-radius: 16px !important;
  border: none;
  backdrop-filter: blur(10px);
  box-shadow: 0 18px 32px rgba(0, 0, 0, 0.12);
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 24px;
`;

const Brand = styled(Title)`
  && {
    margin-bottom: 0;
    color: #2193b0;
  }
`;

const LoginPage = () => {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(selectAuth);
  const navigate = useNavigate();

  const onFinish = async (v: { username: string; password: string }) => {
    try {
      await dispatch(loginThunk(v)).unwrap();
      message.success('로그인이 완료되었습니다.');
      navigate('/', { replace: true });
    } catch {
      message.error('아이디 또는 비밀번호가 올바르지 않습니다.');
    }
  };

  return (
    <Wrapper>
      <StyledCard bordered={false}>
        <Header>
          <Brand level={3}>STIZEN</Brand>
        </Header>

        <Form layout="vertical" onFinish={onFinish} size="large">
          <Form.Item
            name="username"
            label="아이디"
            rules={[{ required: true, message: '아이디를 입력하세요' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="아이디"
              autoComplete="username"
              autoFocus
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="비밀번호"
            rules={[{ required: true, message: '비밀번호를 입력하세요' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="비밀번호"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              block
              style={{ height: 46, borderRadius: 8 }}
              disabled={loading}
            >
              {loading ? <Spin size="small" /> : '로그인'}
            </Button>
          </Form.Item>
        </Form>
      </StyledCard>
    </Wrapper>
  );
};

export default LoginPage;
